import {
  CHATBOT_INJECT_SUCCESS,
  CHATBOT_INIT_SUCCESS,
  CHATBOT_UPDATE_ATTRIBUTES,
  CHATBOT_ADD_LOOKUP_NAMES,
  CHATBOT_ADD_ATTRIBUTES,
  CHATBOT_OPEN_SUCCESS,
  CHATBOT_CLOSE_CONVERSATION,
  CHATBOT_INJECT,
  CHATBOT_LOG_INTAKE_ERROR,
  CHATBOT_LOG_INTAKE_SUCCESS,
  ChatbotActions,
  CHATBOT_OPEN_FAILED_FINAL
} from "../action";

type ChatbotState = {
  status?: "INJECTED" | "INITIALIZED";
  rescueSubmitted: boolean;
  isOpen: boolean;
  attributes: any;
  lookupName?: { firstName: string, lastName: string}
  intakeLog: {
    status: undefined | "error" | "success"
    result: any
  }
  chatUnavailable: boolean;
}

export type OpenChatBotType = {
  retryCount: number
};

const initialState: ChatbotState = {
  status: undefined,
  rescueSubmitted: false,
  isOpen: false,
  attributes: {},
  lookupName: undefined,
  intakeLog: {
    status: undefined,
    result: undefined,
  },
  chatUnavailable: false,
};

export default function (state = initialState, action: ChatbotActions): ChatbotState {
  switch (action.type) {
    case CHATBOT_INJECT:
      return {
        ...state,
        rescueSubmitted: action.payload.rescueSubmitted,
      };
    case CHATBOT_INJECT_SUCCESS:
      return {
        ...state,
        status: "INJECTED",
      };
    case CHATBOT_INIT_SUCCESS:
      return {
        ...state,
        status: "INITIALIZED",
      };
    case CHATBOT_ADD_LOOKUP_NAMES:
      return { ...state, lookupName: action.payload };
    case CHATBOT_ADD_ATTRIBUTES:
      return { ...state, attributes: action.payload };
    case CHATBOT_UPDATE_ATTRIBUTES:
      return {
        ...state,
        attributes: {
          ...state.attributes,
          ...action.payload,
         },
      };
    case CHATBOT_OPEN_SUCCESS:
      return {
        ...state,
        isOpen: true,
      };
    case CHATBOT_CLOSE_CONVERSATION:
      return {
        ...state,
        isOpen: false,
      };
    case CHATBOT_LOG_INTAKE_ERROR:
      return {
        ...state,
        intakeLog: {
          status: "error",
          result: action.payload,
        }
      }
    case CHATBOT_LOG_INTAKE_SUCCESS:
      return {
        ...state,
        intakeLog: {
          status: "success",
          result: action.payload,
        }
      }
    case CHATBOT_OPEN_FAILED_FINAL:
      return {
        ...state,
        chatUnavailable: true,
      };
    default:
      return state;
  }
}
